import { RouteType } from '../types/routes'
import RootPage from '../pages/Root'
import LocaleGuard from '../guards/LocaleGuard'
import HomePage from '../pages/Root/Home'
import Page404 from '../pages/Page404'
import LegalsPage from '../pages/Root/Legals'
import ModifyPage from '../pages/Root/Modify'
// import PrivacyPage from '../pages/Root/Privacy'
import CancelPage from '../pages/Root/Cancel'
import PrivacyPage from '../pages/Root/Privacy'

import { routesPath } from './index'

const publicRoutes: RouteType = {
  path: '',
  component: null,
  guard: LocaleGuard,
  children: [
    {
      path: routesPath.legals,
      name: 'Legals',
      component: LegalsPage,
    },
    {
      path: routesPath.privacy,
      name: 'Privacy',
      component: PrivacyPage,
    },
    {
      path: routesPath.root,
      name: 'Root',
      component: RootPage,
    },
    {
      path: routesPath.modify,
      name: 'Modify',
      component: ModifyPage,
    },
    {
      path: routesPath.cancel,
      name: 'Cancel',
      component: CancelPage,
    },
    {
      path: routesPath.home,
      name: 'Home',
      component: HomePage,
    },
    {
      path: routesPath.notFound,
      name: 'Notfound',
      component: Page404,
    },
  ],
}

export const defaultLayoutRoutes = [publicRoutes]
